var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.368835 25C0.368835 11.1929 11.5617 0 25.3688 0C39.176 0 50.3688 11.1929 50.3688 25C50.3688 38.8071 39.176 50 25.3688 50C11.5617 50 0.368835 38.8071 0.368835 25ZM13.1813 20.7813V37.5H18.4938V20.7813H13.1813ZM12.8688 15.4688C12.8688 17.1875 14.1188 18.4375 15.8376 18.4375C17.5563 18.4375 18.8063 17.1875 18.8063 15.4688C18.8063 13.75 17.5563 12.5 15.8376 12.5C14.2751 12.5 12.8688 13.75 12.8688 15.4688ZM32.5563 37.5H37.5563V27.1875C37.5563 22.0312 34.4313 20.3125 31.4626 20.3125C28.8063 20.3125 26.9313 22.0312 26.4626 23.125V20.7813H21.4626V37.5H26.7751V28.5938C26.7751 26.25 28.3376 25 29.9001 25C31.4626 25 32.5563 25.7812 32.5563 28.4375V37.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linkedInIcon.3a78603dd9c2b8221cb66c67ce4a487e.svg";
export { ForwardRef as ReactComponent };